(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("cropPictureService", ["$uibModal", "cropPictureResource", cropPictureService]);
    function cropPictureService($uibModal, cropPictureResource) {
        var cropPictureServiceFactory = {
            changePicture: changePicture,
            removeTempFolder: removeTempFolder
        };
        function changePicture(cropData, jcropConfig, options) {
            return $uibModal.open({
                templateUrl: "app/modals/cropPicture/cropPictureModalView.html",
                controller: "CropPictureModalCtrl as vm",
                backdrop: "static",
                resolve: {
                    cropData: function () {
                        if (!cropData || !cropData.hasOwnProperty("fileUrl"))
                            return null;
                        return cropData;
                    },
                    jcropConfig: function () {
                        if (!jcropConfig)
                            return {};
                        return jcropConfig;
                    },
                    options: function () {
                        if (!options)
                            return {};
                        return options;
                    }
                }
            });
        }
        function removeTempFolder(tempFolderGuid) {
            return cropPictureResource.removeTempFolder({ tempFolderGuid: tempFolderGuid });
        }
        return cropPictureServiceFactory;
    }
}());
